import React from 'react';
import { c as classnames } from '../../../index-2586sEvh.js';
import '../../../_commonjsHelpers-jjO7Zipk.js';

const ModalHeader = ({ title, capitalize, headingId }) => (React.createElement("div", { className: `modal-header ${title ? 'has-heading' : 'no-heading'}` }, title && (React.createElement("h2", { id: "modal-heading", ...(headingId ? { id: headingId } : {}), className: classnames('modal-title', { capitalize }), dangerouslySetInnerHTML: {
        __html: title ? JSON.stringify(title).replace(/["]+/g, '') : '',
    } }))));

export { ModalHeader as default };
//# sourceMappingURL=index.js.map
